(function () {
  var STORAGE_KEY = 'soulrang:wishlist';

  function readIds() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeIds(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: ids } }));
  }

  var Wishlist = {
    all: readIds,
    has: function (handle) {
      return readIds().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      var ids = readIds();
      var index = ids.indexOf(handle);
      if (index === -1) {
        ids.push(handle);
      } else {
        ids.splice(index, 1);
      }
      writeIds(ids);
      return index === -1;
    },
    remove: function (handle) {
      writeIds(readIds().filter(function (id) {
        return id !== handle;
      }));
    }
  };

  window.SoulrangWishlist = Wishlist;

  function syncButton(button) {
    var handle = button.dataset.productHandle;
    var active = Wishlist.has(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = button.querySelector('[data-wishlist-label]');
    if (label) {
      label.textContent = active ? 'Added to wishlist' : 'Add to wishlist';
    }
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  function syncCount() {
    var bubble = document.querySelector('[data-wishlist-count]');
    if (!bubble) return;
    var count = Wishlist.all().length;
    bubble.textContent = count;
    bubble.hidden = count === 0;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    Wishlist.toggle(button.dataset.productHandle);
  });

  document.addEventListener('wishlist:updated', function () {
    syncAllButtons();
    syncCount();
  });

  function init() {
    syncAllButtons();
    syncCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
